import { Navigate, Outlet } from 'react-router'

import { AircallProvider } from '../../../../components/Aircall/AircallProvider'
import { AircallWidget } from '../../../../components/Aircall/AircallWidget'
import { CommsBottomBar } from '../../../../components/CommsBottomBar'
import { DialpadProvider } from '../../../../components/Dialpad/DialpadProvider'
import { DialpadWidget } from '../../../../components/Dialpad/DialpadWidget'
import { InternalAgentDrawer } from '../../../../components/InternalAgent/InternalAgentDrawer'
import { InternalAgentProvider } from '../../../../components/InternalAgent/InternalAgentProvider'
import { useCurrentUser } from '../../../../models/user'
import { CallLeadDrawer } from './SalesLeads/CallLeadDrawer'

export function InternalLayout() {
  const { user } = useCurrentUser({ enabled: true })

  if (!user?.isCaiAdmin) {
    return <Navigate to="/insure/insurance" />
  }

  // The Aircall + Dialpad iframes and their bottom-bar pills mount HERE, not on
  // individual pages. React Router doesn't unmount InternalLayout when staff
  // navigates between /sales-leads, /tasks, etc. — so a live call survives
  // page changes. The Dialpad pill stacks just above the Aircall one.
  return (
    <AircallProvider>
      <DialpadProvider>
        {/* Above the Outlet for the same reason: the agent panel and its page context survive navigation. */}
        <InternalAgentProvider>
          {/* Reserve space for the fixed 50px comms bar; a flex column so split views can fill the viewport. */}
          <div className="flex flex-1 flex-col pb-[50px]">
            <Outlet />
          </div>
          <AircallWidget />
          <DialpadWidget />
          <CommsBottomBar />
          <InternalAgentDrawer />
          {/* Right-side lead drawer opened by the comms bar's incoming-call CTA. */}
          <CallLeadDrawer />
        </InternalAgentProvider>
      </DialpadProvider>
    </AircallProvider>
  )
}
